import * as React from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import { Button } from "antd";

const AnalysisNav = () => {
	const user = useSelector((state) => state.auth.user);
	const history = useHistory();
	const isLoading = useSelector((state) => state.common.loading);

	const pathname = history.location.pathname;

	const handleAnalysisNav = (e) => {
		const { id } = e.currentTarget;
		history.push(`/reports_analysis/${id}`);
	};

	return (
		<div className={`round-nav-group`}>
			<Button
				className={pathname.includes("category") ? `clicked` : ""}
				id={`category`}
				onClick={handleAnalysisNav}
				disabled={isLoading}
			>
				카테고리
			</Button>
			{user?.id !== 7 && (
				<Button
					className={pathname.includes("contents") ? `clicked` : ""}
					id={`contents`}
					onClick={handleAnalysisNav}
					disabled={isLoading}
				>
					콘텐츠
				</Button>
			)}
			<Button
				className={pathname.includes("products") ? `clicked` : ""}
				id={`products`}
				onClick={handleAnalysisNav}
				disabled={isLoading}
			>
				영양제
			</Button>
		</div>
	);
};

export default AnalysisNav;
